import { connect } from 'react-redux';

import Alert from '../components/Alert';

import { openDialog, closeDialog, openDialogWithFile, openParkingDialog } from '../redux/alert';
import { cancelShift } from '../redux/dashboard';
import { tryFormEditSelect } from '../redux/apply'; // this is used to edit the image upload name in redux
import { tryUpdateProfilePic, retrieveProfile } from '../redux/profile';
import { postComment } from '../redux/parkingData';

const mapStateToProps = ({ alert, parkingAuth }) => ({
  ...alert,
  username: parkingAuth.username,
});

const mapDispatchToProps = dispatch => ({
  openDialog: (dialogType, bookingIdToDelete) => dispatch(openDialog(dialogType, bookingIdToDelete)),
  closeDialog: () => dispatch(closeDialog()),
  openDialogWithFile: (dialogType, file) => dispatch(openDialogWithFile(dialogType, file)),
  cancelShift: bookingId => dispatch(cancelShift(bookingId)),
  tryFormEditSelect: (field, payload) => dispatch(tryFormEditSelect(field, payload)),
  tryUpdateProfilePic: file => dispatch(tryUpdateProfilePic(file)),
  retrieveProfile: () => dispatch(retrieveProfile()),
  openParkingDialog: (dialogType, booking) => dispatch(openParkingDialog(dialogType, booking)),
  postComment: newComment => dispatch(postComment(newComment)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Alert);



// WEBPACK FOOTER //
// ./src/containers/Alert.js